// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

/**
 * Remove tags from string
 */
const stripTags = (str: string): string => str.replace(/<\/?[^>]+(>|$)/g, '');

export default stripTags;
